import { TransactionTypeChar } from '@tassat/common-definitions';
import { AssetTypes } from '@tassat/ui-definitions';

const getCurrencyAmount = (asset, data) => {
    return ((asset.Type === AssetTypes.CURRENCY &&
        (data.type === TransactionTypeChar.deposit ||
            data.type === TransactionTypeChar.send ||
            data.type === TransactionTypeChar.withdrawal ||
            data.type === TransactionTypeChar.transfer ||
            data.type === TransactionTypeChar.receive)
    ) ? data.AssetQuantity : data.FiatAmount);
};

const showSecurityCurrentBalanceAmount = (currency, data) => !(currency.Type === AssetTypes.CURRENCY && (
    data.type === TransactionTypeChar.deposit ||
    data.type === TransactionTypeChar.transfer ||
    data.type === TransactionTypeChar.send ||
    data.type === TransactionTypeChar.withdrawal ||
    data.type === TransactionTypeChar.receive ||
    data.type === TransactionTypeChar.int_distribution
    )
);

const showCcyCurrentBalanceAmount = (currency, data) => !(currency.Type === AssetTypes.ASSET && (
    data.type === TransactionTypeChar.transfer ||
    data.type === TransactionTypeChar.send ||
    data.type === TransactionTypeChar.int_distribution ||
    data.type === TransactionTypeChar.receive)
);

const getCurrentBalances = (data) => {
    let senderBalance = true;

    if (
        data.type === TransactionTypeChar.receive ||
        data.type === TransactionTypeChar.withdrawal ||
        data.type === TransactionTypeChar.int_distribution
    ) {
        senderBalance = false;
    }

    return ({
        fiatBalance: senderBalance ? data.SenderFiatCurrentBalance : data.RecipientFiatCurrentBalance,
        assetBalance: senderBalance ? data.SenderAssetCurrentBalance : data.RecipientAssetCurrentBalance
    });
};

const getTransactionDirectionData = (direction, data) => {
    let mappedData = {
        firm: '',
        accountName: ''
    };

    if (direction === 'sender') {
        if (data.type !== TransactionTypeChar.deposit) {
            if (data.type === TransactionTypeChar.withdrawal) {
                mappedData = {
                    firm: data.RecipientFirm,
                    accountName: data.RecipientAccountName
                };
            } else {
                mappedData = {
                    firm: data.SenderFirm,
                    accountName: data.SenderAccountName
                };
            }
        }
    } else {
        if (data.type === TransactionTypeChar.deposit) {
            mappedData = {
                firm: data.SenderFirm,
                accountName: data.SenderAccountName
            };
        } else if (
            data.type !== TransactionTypeChar.order &&
            data.type !== TransactionTypeChar.withdrawal
        ) {
            mappedData = {
                firm: data.RecipientFirm,
                accountName: data.RecipientAccountName
            };
        }
    }

    return mappedData;
};

export {
    getCurrencyAmount,
    getCurrentBalances,
    showCcyCurrentBalanceAmount,
    showSecurityCurrentBalanceAmount,
    getTransactionDirectionData
};